<template>
  <slot name="loading" v-if="showCustomLoadingScreen() && state == ApiRequestStatus.Loading" />
  <LoadingMessage v-else-if="state == ApiRequestStatus.Loading"></LoadingMessage>
  <LoadingMessage v-else-if="state == ApiRequestStatus.Idle"></LoadingMessage>
  <ErrorPage v-else-if="state == ApiRequestStatus.Error" type="systemError"></ErrorPage>
  <slot v-else-if="state == ApiRequestStatus.Success || state == ApiRequestStatus.Reloading" />
</template>

<script setup lang="ts">
import { ApiRequestStatus } from '@/core/models/api/api-request-status'
import ErrorPage from '../../../modules/app/pages/ErrorPage.vue'
import LoadingMessage from './LoadingMessage.vue'
import { useSlots } from 'vue'

const slots = useSlots()
const showCustomLoadingScreen = () => !!slots.loading

interface Props {
  state: ApiRequestStatus
}

defineProps<Props>()
</script>
